import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {CalculatorService} from "../../../../services/calculator/calculatorService";
import {OrderItem} from "../../../../objects/orders/orderItem";
import {Order} from "../../../../objects/orders/order";
import {OrderService} from "../../../../services/orderService";
import {ScreenHelper} from "../../../../common/helpers/screenHelper";
import {ViewType} from "../../../../objects/users/viewType";
import {Duty, DutyType} from "../../../../objects/calculator/duty";
import {TaxType} from "../../../../objects/orders/taxType";
import {BaseCalculatorTab} from "../calculatorResults/baseCalculatorTab";
import {CalculatorHelper} from "../../../../common/helpers/calculatorHelper";

/**
 * Created by alex.y on 8/10/2017.
 */
@Component({
    selector: "calc-info-row",
    templateUrl: "./calcInfoRow.component.html",
    moduleId: module.id.toString(),
    host: {
        '(document:mousedown)': 'onClick($event)',
    }
})
export class CalcInfoRowComponent extends BaseCalculatorTab implements OnInit{
    @Input() public title: string;

    @Input() public percent: string;
    @Input() public value: number = null;

    @Input() public class: string = "";
    @Input() public isBigRow: boolean = false;
    @Input() public isMobileVersion: boolean = false;
    @Input() public currencyExchange: string;
    @Input() public orderItem: OrderItem;
    @Input() public isEditable: boolean = false;

    @Input('currency')
    public currency: string;

    @Input() public previousValue: number = null;
    @Input() public previousPercent: string = null;
    @Input() public order: Order = new Order();

    public canInputPercent: boolean = false;
    public viewTypeEnum: ViewType;
    public viewType: string;

    constructor(public calculatorService: CalculatorService, public orderService: OrderService, public cdr: ChangeDetectorRef){
        super();
    }

    ngOnInit(): void {
        this.viewTypeEnum = ScreenHelper.getViewType();
        this.viewType = ViewType[this.viewTypeEnum];
    }

    public isNumber(value: any): boolean{
        return !isNaN(value);
    }

    public showInputField(){
        if(this.isEditable){
            this.canInputPercent = true;
        }
    }

    public hideInputField(){
        this.canInputPercent = false;
    }

    public checkTartget(classLict: any): boolean{
        for(let i of classLict){
            if(i == 'percent-input'){
               return true;
            }
        }
        return false;
    }

    public checkEnter(e: any){
        if(e.keyCode == 13){
           e.preventDefault();
           e.stopPropagation();
            this.recalculate();
        }
    }

    public recalculate(): void{

        this.hideInputField();

        this.order.OrderItems.map((i) => {

            if(i.Id == this.orderItem.Id){
                i.DutyList.map(d => {
                    if(d.DutyType == DutyType.Percent){
                        d.Value = parseFloat(this.percent)
                    }
                });

                if (!i.DutyList.length) {
                    i.DutyList.push(new Duty({
                        DutyType: DutyType.Percent,
                        Measure: '%',
                        Value: parseFloat(this.percent)
                    }))
                }

                i.IsAgentEditCustomDuty = true;
                i.AgentEditedCustomDutyPercent = parseFloat(this.percent);
                i.Total.Taxes.map(t => {
                    if(t.Type == TaxType.CustomDuty){
                        t.Percentage = parseFloat(this.percent);
                        t.Value = this.getCadValue(i.Price, i.CanadianCurrencyCode, this.order.Currency) * t.Percentage / 100;
                    }
                    if(t.Type == TaxType.CustomGST){
                        let cd = i.Total.Taxes.find(ft => ft.Type == TaxType.CustomDuty);
                        t.Value = (this.getCadValue(i.Price, i.CanadianCurrencyCode, this.order.Currency) + cd.Value)  / 100 * t.Percentage
                    }
                    if(t.Type == TaxType.CustomPST){
                        let cd = i.Total.Taxes.find(ft => ft.Type == TaxType.CustomDuty);
                        let cadVal = this.getCadValue(i.Price, i.CanadianCurrencyCode, this.order.Currency)
                        t.Value = (cadVal / 100 * t.Percentage) + (cd.Value / 100 * t.Percentage)
                    }
                });
                i.Total.TotalPrice = CalculatorHelper.calculateGrantTotalForItem(i, this.order);
            }
        });

        this.percent = `${parseFloat(this.percent)}%`

        this.orderService.create(this.order,this.viewType).then(response => {
            //var newOrder = JSON.parse(JSON.stringify(response.Data));
            // this.order = newOrder;
            // this.cdr.detectChanges();
        });
    }

    public onClick(event: any) {
        if(this.isEditable){
            if (this.canInputPercent && !this.checkTartget(event.target.classList) && !String.isNullOrEmpty(this.percent)) {
                this.recalculate();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/tabs/calcInfoRow/calcInfoRow.component.ts